import { useLayoutEffect } from 'react';

// Match the natural content heights without coupling either card's open state.
export function useBenchmarkAlignment(sectionRef) {
  useLayoutEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const alignHeights = () => {
      ['summary', 'category'].forEach(kind => {
        const elements = section.querySelectorAll(`[data-benchmark-${kind}-content]`);
        const height = Math.ceil(Math.max(0, ...Array.from(elements, element => element.getBoundingClientRect().height)));
        section.style.setProperty(`--benchmark-${kind}-height`, `${height}px`);
      });
    };

    const resizeObserver = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(alignHeights);
    const observeContent = () => {
      resizeObserver?.disconnect();
      section.querySelectorAll('[data-benchmark-summary-content], [data-benchmark-category-content]')
        .forEach(element => resizeObserver?.observe(element));
      alignHeights();
    };
    const mutationObserver = new MutationObserver(observeContent);
    mutationObserver.observe(section, { childList: true, subtree: true, characterData: true });
    window.addEventListener('resize', alignHeights);
    observeContent();

    return () => {
      resizeObserver?.disconnect();
      mutationObserver.disconnect();
      window.removeEventListener('resize', alignHeights);
    };
  }, [sectionRef]);
}
